import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded';
import EdgesensorHighRoundedIcon from '@mui/icons-material/EdgesensorHighRounded';
import ViewQuiltRoundedIcon from '@mui/icons-material/ViewQuiltRounded';

import HubRoundedIcon from '@mui/icons-material/HubRounded';
import NoteAltRoundedIcon from '@mui/icons-material/NoteAltRounded';
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';

import { useTranslation } from 'react-i18next';

const items = [
  {
    icon: <NoteAltRoundedIcon />,
    imageLight: 'url("https://www.zaping.io/images/zaping_instructions.png")',
    imageDark: 'url("https://www.zaping.io/images/zaping_instructions.png")',
  },
  {
    icon: <CloudUploadRoundedIcon />,
    imageLight: 'url("https://www.zaping.io/images/zaping_files.png")',
    imageDark: 'url("https://www.zaping.io/images/zaping_files.png")',
  },
  {
    icon: <HubRoundedIcon />,
    imageLight: 'url("https://www.zaping.io/images/zaping_api.png")',
    imageDark: 'url("https://www.zaping.io/images/zaping_api.png")'
  },  
  {
    icon: <ViewQuiltRoundedIcon />,
    imageLight: 'url("https://www.zaping.io/images/zaping_widget.png")',
    imageDark: 'url("https://www.zaping.io/images/zaping_widget.png")'
  },
  {
    icon: <ViewQuiltRoundedIcon />,
    imageLight: 'url("https://www.zaping.io/images/zaping_dashboard.png")',
    imageDark: 'url("https://www.zaping.io/images/zaping_dashboard.png")'
  }
];

export default function Features() {
  const { t } = useTranslation();
  
  console.log(t('featuresWaVideo'))

  const [selectedItemIndex, setSelectedItemIndex] = React.useState(0);

  const handleItemClick = (index) => {
    setSelectedItemIndex(index);
  };

  const selectedFeature = items[selectedItemIndex];

  React.useEffect(() => {
    const interval = setInterval(() => {
      setSelectedItemIndex((prevIndex) => {
        // Determine the next index. If we've reached the end of the items array, loop back to 0.
        const nextIndex = prevIndex + 1 === items.length ? 0 : prevIndex + 1;
        return nextIndex;
      });
    }, 3000); // Change the selectedItemIndex every 5000ms (5 seconds)
  
    return () => {
      clearInterval(interval); // Clear the interval on component unmount
    };
  }, [items.length]); // The effect's dependency is items.length to ensure the interval is reset if the number of items changes  

  return (
    <Container id="features" sx={{ py: { xs: 8, sm: 16 } }}>
      <Grid container spacing={6}>

        <Grid
          item
          xs={12}
          md={6}
          sx={{ height: '25%', width: 'auto' }}
        >
          <video autoPlay loop muted style={{paddingLeft: '15%', width: '75%', height: 'auto'}}>
            <source src={t('featuresWaVideo')} type="video/mp4" />
          </video>  
        </Grid>

        <Grid item xs={12} md={6}>
          <br />
          <br />
          <br />
          <br />
          <Typography component="h5" variant="h5" color="text.secondary">
            {t('features1')}
            <br />
            <br />            
            {t('features2')}
            <br />
            <br />
            {t('features3')}
            <br />
            <br />
            {t('features4')}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={6}>
        <Grid item xs={12} md={6}>
          <div>
            <br />
            <Typography component="h2" variant="h4" color="text.primary">
              {t('menuOption1')}
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mb: { xs: 2, sm: 4 } }}
            >
              {t('features5')}
            </Typography>
          </div>
          <Grid container item gap={1} sx={{ display: { xs: 'auto', sm: 'none' } }}>
            {items.map(({ title }, index) => (
              <Chip
                key={index}
                label={t(`featuresItems.${index}.title`)}
                onClick={() => handleItemClick(index)}
                sx={{
                  borderColor: (theme) => {
                    if (theme.palette.mode === 'light') {
                      return selectedItemIndex === index ? 'primary.light' : '';
                    }
                    return selectedItemIndex === index ? 'primary.light' : '';
                  },
                  background: (theme) => {
                    if (theme.palette.mode === 'light') {
                      return selectedItemIndex === index ? 'none' : '';
                    }
                    return selectedItemIndex === index ? 'none' : '';
                  },
                  backgroundColor: selectedItemIndex === index ? 'primary.main' : '',
                  '& .MuiChip-label': {
                    color: selectedItemIndex === index ? '#fff' : '',
                  },
                }}
              />
            ))}
          </Grid>
          <Box
            component={Card}
            variant="outlined"
            sx={{
              display: { xs: 'auto', sm: 'none' },
              mt: 4,
            }}
          >
            <Box
              sx={{
                backgroundImage: (theme) =>
                  theme.palette.mode === 'light'
                    ? items[selectedItemIndex].imageLight
                    : items[selectedItemIndex].imageDark,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: 280,
              }}
            />
            <Box sx={{ px: 2, pb: 2 }}>
              <Typography color="text.primary" variant="body2" fontWeight="bold">
              </Typography>
              <Typography color="text.secondary" variant="body2" sx={{ my: 0.5 }}>
              </Typography>
              <Link
                color="primary"
                variant="body2"
                fontWeight="bold"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  '& > svg': { transition: '0.2s' },
                  '&:hover > svg': { transform: 'translateX(2px)' },
                }}
              >
                <ChevronRightRoundedIcon
                  fontSize="small"
                  sx={{ mt: '1px', ml: '2px' }}
                />
              </Link>
            </Box>
          </Box>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
            useFlexGap
            sx={{ width: '100%', display: { xs: 'none', sm: 'flex' } }}
          >
            {items.map(({ icon }, index) => (
              <Card
                key={index}
                component={Button}
                onClick={() => handleItemClick(index)}
                sx={{
                  p: 3,
                  height: 'fit-content',
                  width: '100%',
                  background: 'none',
                  backgroundColor:
                    selectedItemIndex === index ? 'action.selected' : undefined,
                  borderColor: (theme) => {
                    if (theme.palette.mode === 'light') {
                      return selectedItemIndex === index
                        ? 'primary.light'
                        : 'grey.200';
                    }
                    return selectedItemIndex === index ? 'primary.dark' : 'grey.800';
                  },
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    textAlign: 'left',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { md: 'center' },
                    gap: 2.5,
                  }}
                >
                  <Box
                    sx={{
                      color: (theme) => {
                        if (theme.palette.mode === 'light') {
                          return selectedItemIndex === index
                            ? 'primary.main'
                            : 'grey.300';
                        }
                        return selectedItemIndex === index
                          ? 'primary.main'
                          : 'grey.700';
                      },
                    }}
                  >
                    {icon}
                  </Box>
                  <div>
                    <Typography
                      color="text.primary"
                      variant="body2"
                      fontWeight="bold"
                    >
                      {t(`featuresItems.${index}.title`)}
                    </Typography>
                    <Typography
                      color="text.secondary"
                      variant="body2"
                      sx={{ my: 0.5 }}
                    >
                      {t(`featuresItems.${index}.description`)}
                    </Typography>
                   
                  </div>
                </Box>
              </Card>
            ))}
          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: { xs: 'none', sm: 'flex' }, width: '100%' }}
        >
          <Card
            variant="outlined"
            sx={{
              height: '100%',
              width: '100%',
              display: { xs: 'none', sm: 'flex' },
              pointerEvents: 'none',
            }}
          >
            <Box
              sx={{
                m: 'auto',
                width: 420,
                height: 500,
                backgroundSize: 'contain',
                backgroundImage: (theme) =>
                  theme.palette.mode === 'light'
                    ? items[selectedItemIndex].imageLight
                    : items[selectedItemIndex].imageDark,
              }}
            />
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
